import React, { useState } from 'react'
import { Col, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import InputEvaluatesForm from '../InputEvaluatesForm'
import { saveProjectEvaluation } from '../../../redux/actions/projectEvaluation'

export default function CoworkerEvaluateThaihealthWidget(props) {
  // const { projectId, projectProgressId } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { disabled, isEditAll, isApprove, evaluationId = () => {} } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const projectId = sessionStorage.getItem('projectId')
  const projectProgressId = '99'
  // console.log('disabled======>', disabled)
  // console.log('formSchema==>', formSchema.evaluationId)

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)

    try {
      const response = await saveProjectEvaluation(projectId, projectProgressId, requestBody)

      if (response) {
        evaluationId(response.evaluationId)
        // sessionSetItemStr('subIncomeId', response.model.id)
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })
        setIsShowConfirm(false)

        // setTimeout(() => {
        //   location.reload()
        // }, 1000)
      } else {
        notification.open('success', {
          title: globalMsgUtil.SET_IS_ERROR,
        })
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('success', {
          title: e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR,
        })
      } else {
        notification.open('success', {
          title: globalMsgUtil.SET_IS_ERROR,
        })
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('on submit ', data)

    let newArr = []
    for (const key in data) {
      console.log(`${key}: ${data[key]}`)
      let newRes = {
        id: key,
        result: Array.isArray(data[key]) ? data[key].toString() : data[key],
        otherResult: '',
      }

      newArr.push(newRes)
    }

    const requestBody = {
      evaluationId: '',
      comment: '',
      results: newArr,
    }

    console.log('requestBody => ', requestBody)
    setRequestBody(requestBody)
    setIsShowConfirm(true)
    // console.log('data', data)
  }

  return (
    <>
      {formSchema?.evaluationRounds?.length > 0 &&
        formSchema?.evaluationRounds?.map((rounds) => {
          // console.log('rounds', rounds)
          return (
            <Panel
              header={rounds.header}
              key={rounds.period}
              shaded
              bordered
              collapsible
              defaultExpanded
              style={{ marginBottom: '1em' }}
            >
              {rounds?.evaluations?.length > 0 &&
                rounds?.evaluations?.map((evaluations) => {
                  // console.log('evaluations', evaluations)
                  return (
                    <Panel
                      header={evaluations.name}
                      key={evaluations.code}
                      style={{ marginTop: -30 }}
                    >
                      {evaluations?.questions?.length > 0 && (
                        <InputEvaluatesForm
                          schema={evaluations?.questions}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          getValues={getValues}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          setIsEnableEdit={setIsEnableEdit}
                          disabled={disabled}
                        />
                      )}
                    </Panel>
                  )
                })}
              <hr />
              {!disabled && (
                <Row style={{ marginTop: 20 }}>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <SaveButton
                      onClick={handleSubmit(onSubmit)}
                      style={{ marginTop: 0, marginLeft: 0 }}
                      disabled={isLoading}
                    >
                      {'บันทึกผล'}
                    </SaveButton>
                    {/* <CancelButton style={{ marginTop: 0, marginLeft: 20 }}>{'ยกเลิก'}</CancelButton> */}
                  </Col>
                </Row>
              )}
            </Panel>
          )
        })}

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />
    </>
  )
}
